import { useState } from "react";
import DatePicker from "react-datepicker";
import { ErrorMessage, Field, Form, Formik } from "formik";
import dayjs from 'dayjs';
import { toast } from "react-toastify";

const MultiFieldModal = ({ handleCloseModal, fields, containerFieldName, modalTitle, setFieldValue, initialData = [], disabled }) => {
  const [modalFields, setModalFields] = useState(initialData);
  const [editIndex, setEditIndex] = useState(null);

  console.log("MultiFieldModal rendered with fields:", initialData);
  const formatValues = (values) => {
    const formattedData = { ...values };
    fields.forEach((field) => {
      if (field.type === 'date' && values[field.fieldName]) {
        formattedData[field.fieldName] = dayjs(values[field.fieldName]).format('YYYY-MM');
      }
    });
    return formattedData;
  };

  const getInitialValues = () => {
    if (editIndex !== null) {
      return fields.reduce((acc, field) => {
        acc[field.fieldName] = field.type === 'date'
          ? new Date(modalFields[editIndex][field.fieldName] + "-01")
          : modalFields[editIndex][field.fieldName];
        return acc;
      }, {});
    }
    return fields.reduce((acc, field) => {
      acc[field.fieldName] = field.type === 'date' ? null : '';
      return acc;
    }, {});
  };
  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{modalTitle}</h5>
            <button type="button" className="btn-close" onClick={handleCloseModal}></button>
          </div>

          <Formik initialValues={getInitialValues()} enableReinitialize>
            {({ values, setFieldValue: setFormikFieldValue, resetForm }) => (
              <Form>
                <div className="modal-body row" hidden={disabled}>
                  {fields.filter(field => field.fieldName !== "id").
                    map((field, index) => (
                      <div key={index} className="col-md-6 py-2">
                        <label className="form-label">{field.fieldLabel}</label>
                        {field.type === "date" ? (
                          <DatePicker
                            className="form-control"
                            selected={values[field.fieldName]}
                            onChange={(date) => setFormikFieldValue(field.fieldName, date)}
                            showMonthYearPicker
                            dateFormat="MM/yyyy"
                            placeholderText={field.placeholder}
                            disabled={disabled}
                          />
                        ) : field.type === "text" ? (
                          <>
                            <Field
                              name={field.fieldName}
                              className="form-control"
                              placeholder={field.placeholder}
                              type={field.type}
                              disabled={disabled}
                            />
                            <ErrorMessage name={field.fieldName} component="div" className="text-danger" />
                          </>
                        ) : field.type === "number" ? (
                          <>
                            <Field
                              name={field.fieldName}
                              className="form-control"
                              placeholder={field.placeholder}
                              type={field.type}
                              disabled={disabled}
                            />
                            <ErrorMessage name={field.fieldName} component="div" className="text-danger" />
                          </>
                        ) : null}
                      </div>
                    ))}
                </div>

                {modalFields.length > 0 && (
                  <div className="px-3">
                    <h6 className="mt-3" hidden={disabled} >Added Entries</h6>
                    <ul className="list-group">
                      {modalFields
                        .map((item, index) => (
                          <li className="list-group-item d-flex justify-content-between align-items-center" key={index}>
                            {index + 1}
                            <div>
                              {fields.filter((item, index) => item.fieldName != "id").map((field) => (
                                <div key={field.fieldName}>
                                  <strong>{field.fieldLabel}:</strong> {item[field.fieldName]}
                                </div>
                              ))}
                            </div>
                            <div hidden={!disabled} />
                            <button type="button" className="btn btn-sm btn-warning" onClick={() => setEditIndex(index)} hidden={disabled}>
                              Edit
                            </button>
                          </li>
                        ))}

                    </ul>
                  </div>
                )}

                {
                  modalFields.length === 0 && (
                    <li className="list-group-item text-center">
                      No entries added yet.
                    </li>
                  )
                }

                <div className="modal-footer">
                  {editIndex !== null && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      hidden={disabled}
                      onClick={() => {
                        const formatted = formatValues(values);
                        const updatedFields = [...modalFields];
                        updatedFields[editIndex] = formatted;
                        setModalFields(updatedFields);
                        setEditIndex(null);
                      }}
                    >
                      Update
                    </button>
                  )}

                  <button
                    type="button"
                    hidden={disabled}
                    className="btn btn-primary"
                    onClick={() => {
                      const formatted = formatValues(values);
                      console.log(formatValues(values));
                      // Check if all fields are filled (basic validation)
                      const isEmpty = Object.entries(formatted)
                        .filter(([key]) => key !== 'id')
                        .some(([, val]) => val === '' || val === null);

                      if (isEmpty) {
                        // alert("Please fill all fields before adding.");
                        toast.error("Please fill all fields before adding.");
                        return;
                      }

                      setModalFields([...modalFields, formatted]);
                      resetForm();
                    }}
                  >
                    <i className="fas fa-plus px-2"></i>
                  </button>

                  <button
                    type="button"
                    hidden={disabled}
                    className="btn btn-success"
                    onClick={() => {
                      if (modalFields.length > 0) {
                        console.log('---------------------------------');
                        console.log(containerFieldName, modalFields);
                        console.log('---------------------------------');
                        setFieldValue(containerFieldName, modalFields);
                      }
                      handleCloseModal();
                    }}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setEditIndex(null);
                      handleCloseModal();
                    }}
                  >
                    Close
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default MultiFieldModal;
